import { html, LitElement, unsafeCSS } from 'lit';
import { customElement } from 'lit/decorators.js';
import { I18n } from '../../base/package/services/package/i18n/i18n.de';
import '../ui-inlined-svg/ui-inlined-svg';
import iconStyle from './ui-info-icon.css?inline';

const CName = 'ui-info-icon';

@customElement(CName)
export class UIInfoIcon extends LitElement {
  static readonly styles = unsafeCSS(iconStyle);

  render() {
    // Use vite to transform static URL
    const assetUrl = new URL('/assets/ui-core/icons/info-icon.svg', import.meta.url).href;
    return html`<ui-inlined-svg .css=${UIInfoIcon.styles} .defer=${true} .src=${assetUrl} .label=${window.$app.$t.get(I18n.a11y.button.information)}></ui-inlined-svg>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UIInfoIcon;
  }
}
